import { useMutation } from '@apollo/client';
import NEW_FLASHCARD from 'graphql/fragments/NewFlashcard.graphql';
import CREATE_FLASHCARD from 'graphql/mutations/flashcards/CreateFlashcard.graphql';

export default function useCreateFlashcardMutation() {
  return useMutation(CREATE_FLASHCARD, {
    update(cache, { data: { createFlashcard } }) {
      cache.modify({
        fields: {
          flashcardsByEpub(existingFlashcards) {
            const newFlashcardRef = cache.writeFragment({
              data: createFlashcard.flashcard,
              fragment: NEW_FLASHCARD,
            });

            return {
              __typename: existingFlashcards.__typeName,
              edges: [
                ...existingFlashcards.edges,
                {
                  __typename: 'FlashcardNodeEdge',
                  node: newFlashcardRef,
                },
              ],
            };
          },
        },
      });
    },
  });
}
